module.exports = __webpack_public_path__ + "static/media/klatrefelt.82bebd37.svg";